module.exports = __webpack_public_path__ + "static/media/layer.3348fc58.png";